module.exports = __webpack_public_path__ + "img/head-index-box.b2965d6f.png";